<template lang='pug'>
v-layout(class='list' row wrap)
  v-flex(xs12 sm6 md4)
    v-list(dense)
      v-list-tile
        v-list-tile-content(class='grey--text') Объект:
        v-list-tile-content(class='align-end font-weight-medium')
          | {{ step.step_info.object_name }}
      v-list-tile(v-if='!details.info_deal.is_share')
        v-list-tile-content(class='grey--text') Договор:
        v-list-tile-content(class='align-end font-weight-medium')
          | {{ step.step_info.num }} от
          | &laquo;{{ step.step_info.date | date }}&raquo;
      v-list-tile
        v-list-tile-content(class='grey--text') Клиент:
        v-list-tile-content(class='align-end font-weight-medium')
          | {{ step.step_info.client_name }}
      v-list-tile
        v-list-tile-content(class='grey--text') Доля:
        v-list-tile-content(class='align-end font-weight-medium')
          | {{ step.step_info.share }}%
      template(v-if='!details.info_deal.is_share')
        v-list-tile
          v-list-tile-content(class='grey--text') Сумма договора:
          v-list-tile-content(class='align-end font-weight-medium')
            | {{ step.step_info.price | rubles }}
        v-list-tile
          v-list-tile-content(class='grey--text') Дата регистрации в рег. палате:
          v-list-tile-content(class='align-end font-weight-medium')
            | {{ step.step_info.reg_date | date }}
      v-list-tile
        v-list-tile-content(class='grey--text') Дата передачи объекта:
        v-list-tile-content(class='align-end font-weight-medium')
          | {{ step.step_info.date_startup | date }}
      //- Договор ЖНК
      template(v-if='details.info_deal.is_share')
        v-list-tile(v-for='(r, i) in step.step_info.share_info' :key='i')
          v-list-tile-content(class='grey--text') {{ r.key }}
          v-list-tile-content(class='align-end font-weight-medium') {{ r.val }}
  v-flex(xs12 sm5 offset-sm1 md4 offset-md2)
    v-list(dense)
      v-list-tile
        v-list-tile-content(class='grey--text')
          template(v-if='isParking') Парковка
          template(v-else-if='isLiving') Квартира
          template(v-else) Помещение
        v-list-tile-content(class='align-end font-weight-medium')
          | {{ step.step_info.number }}
      v-list-tile
        v-list-tile-content(class='grey--text') Этаж:
        v-list-tile-content(class='align-end font-weight-medium')
          | {{ step.step_info.floor }}
      v-list-tile
        v-list-tile-content(class='grey--text') Площадь:
        v-list-tile-content(class='align-end font-weight-medium')
          span {{ step.step_info.square}}м<sup>2</sup>
      v-list-tile(v-if='isLiving')
        v-list-tile-content(class='grey--text') Жилая площадь:
        v-list-tile-content(class='align-end font-weight-medium')
          span {{ step.step_info.square_living}}м<sup>2</sup>
  v-flex(xs12)
    rhtml(:html='step.html')
  v-flex(xs12)
    images(:images='step.images')
  template(v-if='details.info_deal.is_share')
    v-flex(xs12)
      v-divider(class='my-3')
      v-btn(@click='show = !show' class='ml-0' outline)
        | Платежи
        v-icon(right) {{ show ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
    v-flex(xs12)
      v-slide-y-transition
        div(v-if='show' class='negate')
          s-client-payments(:payments='step.step_info.pays')
</template>

<script>
import Html from './Html';
import Images from './Images';

export default {
  props: ['step', 'client', 'details'],

  components: {
    Rhtml: Html,
    Images
  },

  data: () => ({
    show: false
  }),

  computed: {
    isLiving() {
      return !!this.step.step_info.square_living;
    },

    isParking() {
      let { object_name } = this.step.step_info;
      return object_name.toLowerCase().includes('парковка');
    }
  }
};
</script>

<style scoped>
.list >>> .v-list__tile {
  padding-right: 0;
  padding-left: 0;
}
.negate {
  margin: 0 -24px -17px -24px;
  width: calc(100% + 48px);
}
</style>
